/** Short link carried by the report/survey/disclosure route branches (`/:language/c/:shortId/...`). */
export const getShortIdFromPath = (pathname: string) =>
  pathname.match(/\/(?:q|c|s|d)\/([a-zA-Z0-9_]+)/)?.[1] ?? null

/**
 * ENG-2492: for eleven days in September 2025 akutan's form share modal encoded the survey URL
 * into the QR code it offered for download. This customer printed theirs on material worldwide
 * and cannot reprint, so the survey route hands their short link over to the reporting form the
 * QR was meant to open. Every other dead short link belongs on the unavailable-link page.
 */
const SURVEY_SHORT_LINKS_REDIRECTED_TO_REPORTING_FORM = new Set(['o7se1yaz'])

export const shouldSurveyShortLinkRedirectToReportingForm = (shortId: string | undefined) =>
  shortId !== undefined && SURVEY_SHORT_LINKS_REDIRECTED_TO_REPORTING_FORM.has(shortId)
